import {Pjdb1ButtonProps} from "../../../../components/inputs/Pjdb1Button";
import {WorldDocument} from "../../../../types/pj1dbApiWorld";
import DownloadFileButton from "./DownloadFileButton";

interface DownloadWorldFileButtonProps extends Partial<Pjdb1ButtonProps> {
  world: WorldDocument | null;
}

export default function DownloadWorldFileButton({world, ...props}: DownloadWorldFileButtonProps) {
  const files = world ? [
    {
      id: world.attr["world-id"],
      signedUrls: [
        world.url?.usdz ?? null,
        world.url?.glb ?? null,
      ].filter((url) => url !== null),
    }
  ] : [];

  return (
    <DownloadFileButton
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
      baseFileName='world'
      label="ワールドのダウンロード"
      variant="contained"
      color="info"
      files={files}
      disabled={files.length === 0}
    />
  )
};
